import { useEffect } from "react";
import { createPortal } from "react-dom";
import wizardStyles from "../styles/AddGifteeWizard.module.css";
import sheetStyles from "./GifteeInterestsMoreSheet.module.css";
import { getUsHolidayOccasions } from "../data/usHolidayPresets.js";

export default function GifteeHolidaysMoreSheet({
  open,
  holidayIdsDraft,
  onToggleHoliday,
  onClose,
  onSave,
}) {
  const holidayOccasions = getUsHolidayOccasions();

  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className={sheetStyles.root}>
      <button
        type="button"
        className={sheetStyles.backdrop}
        aria-label="Dismiss holiday picker"
        onClick={onClose}
      />
      <div
        className={sheetStyles.sheet}
        role="dialog"
        aria-modal="true"
        aria-labelledby="giftee-holidays-sheet-heading"
      >
        <button
          type="button"
          className={sheetStyles.sheetClose}
          onClick={onClose}
          aria-label="Close"
        >
          <i className="fa-solid fa-xmark" aria-hidden />
        </button>
        <div className={sheetStyles.sheetBody}>
          <div
            className={wizardStyles.celebrationsOrderedList}
            style={{ marginTop: 0, width: "100%", maxWidth: "100%" }}
          >
            <div className={wizardStyles.celebrationSection}>
              <p
                id="giftee-holidays-sheet-heading"
                className={wizardStyles.celebrationSectionLabel}
              >
                U.S. Holidays
              </p>
              <div className={wizardStyles.holidayCelebrationStack}>
                {holidayOccasions.map((occ) => {
                  const selected = holidayIdsDraft.has(occ.id);
                  return (
                    <button
                      key={occ.id}
                      type="button"
                      className={`${wizardStyles.holidayCelebrationChip} ${
                        selected ? wizardStyles.holidayCelebrationChipSelected : ""
                      }`}
                      onClick={() => onToggleHoliday(occ.id)}
                      aria-pressed={selected}
                    >
                      <span>{occ.name}</span>
                      <span className={wizardStyles.celebrationChipDate}>
                        {occ.date}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className={sheetStyles.sheetFooter}>
          <button
            type="button"
            className={wizardStyles.customInterestSaveBtn}
            onClick={onSave}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
